import { Foundation } from '@models';

export interface AllFoundationsResult {
  foundations: Foundation[];
}
